/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Replace_DocInputs */

const en_action_replace_doc = /** @type {(inputs: Action_Replace_DocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace Document`)
};

const es_action_replace_doc = /** @type {(inputs: Action_Replace_DocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplazar Documento`)
};

const fr_action_replace_doc = /** @type {(inputs: Action_Replace_DocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacer le document`)
};

const de_action_replace_doc = /** @type {(inputs: Action_Replace_DocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument ersetzen`)
};

const id_action_replace_doc = /** @type {(inputs: Action_Replace_DocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganti Dokumen`)
};

/** @type {(inputs: Action_Replace_DocInputs) => LocalizedString} */
const ja_action_replace_doc = en_action_replace_doc;

/** @type {(inputs: Action_Replace_DocInputs) => LocalizedString} */
const zh_action_replace_doc = en_action_replace_doc;

/** @type {(inputs: Action_Replace_DocInputs) => LocalizedString} */
const ar_action_replace_doc = en_action_replace_doc;

/** @type {(inputs: Action_Replace_DocInputs) => LocalizedString} */
const it_action_replace_doc = en_action_replace_doc;

/** @type {(inputs: Action_Replace_DocInputs) => LocalizedString} */
const ru_action_replace_doc = en_action_replace_doc;

/** @type {(inputs: Action_Replace_DocInputs) => LocalizedString} */
const pt_action_replace_doc = en_action_replace_doc;

/** @type {(inputs: Action_Replace_DocInputs) => LocalizedString} */
const ko_action_replace_doc = en_action_replace_doc;

/**
* | output |
* | --- |
* | "Replace Document" |
*
* @param {Action_Replace_DocInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_replace_doc = /** @type {((inputs?: Action_Replace_DocInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Replace_DocInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_replace_doc(inputs)
	if (locale === "es") return es_action_replace_doc(inputs)
	if (locale === "fr") return fr_action_replace_doc(inputs)
	if (locale === "de") return de_action_replace_doc(inputs)
	if (locale === "ja") return ja_action_replace_doc(inputs)
	if (locale === "zh") return zh_action_replace_doc(inputs)
	if (locale === "ar") return ar_action_replace_doc(inputs)
	if (locale === "id") return id_action_replace_doc(inputs)
	if (locale === "it") return it_action_replace_doc(inputs)
	if (locale === "ru") return ru_action_replace_doc(inputs)
	if (locale === "pt") return pt_action_replace_doc(inputs)
	return ko_action_replace_doc(inputs)
});